<template>
  <v-app>
    <AppBarFrame
      :session="session"
      :environment="environment"
      :generalExApplicationEx="generalExApplicationEx"
      :applicationName="null"
      :customLanguage="customLanguage"
      :external="true"
      :title="title"
      @switch-language="switchLanguage"
      ref="appBarRef"
    />
    <v-container>
      <v-row class="text-center">
        <v-col cols="12">
          <Flap
            v-if="okTransaction()"
            :menu="menu"
            :session="session"
            :environment="environment"
            :generalExApplicationEx="generalExApplicationEx"
            :inputData="inputData"
            :customLanguage="customLanguage"
            :external="{ redirect }"
            @update-notification="updateNotification"
            @switch-language="switchLanguage"
            @transaction-process="transactionProcess"
            ref="flapRef"
          />
          <Notification
            :session="session"
            :environment="environment"
            :notifications="notifications"
            :generalExApplicationEx="generalExApplicationEx"
            :customLanguage="customLanguage"
            ref="notificationRef"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { environment } from "./../../../environment/environment.js";
import Notification from "./Notification";
import Flap from "./../transaction/Flap";
import AppBarFrame from "./AppBarFrame";
import { sha256 } from "js-sha256";
export default {
  name: "External",
  data() {
    return {
      environment: environment,
      session: {},
      generalExApplicationEx: {},
      historyNotif: [],
      notifications: [],
      timeoutNotif: 3000,
      transactionName: null,
      token: null,
      transactionEx: {},
      transactionLoaded: false,
      transactionValidated: false,
      menu: {},
      doLoadFlap: false,
      inputData: {},
      customLanguage: null,
      title: null,
      redirect: null,
    };
  },
  components: {
    Notification,
    Flap,
    AppBarFrame,
  },
  methods: {
    validateToken() {
      const dynamicToken = sha256(
        sha256(
          environment.global.name +
            "_" +
            environment.endpoint.urlBack +
            "_" +
            this.transactionName
        )
      );
      return this.token == dynamicToken;
    },
    loadTransaction() {
      this.transactionLoaded = false;
      this.transactionValidated = false;
      if (this.validateToken()) {
        this.transactionValidated = true;
        this.apiGetExternal({
          path: { transactionName: this.transactionName, token: this.token },
        })
          .then((response) => {
            if (this.getApiSuccess(response.data)) {
              this.transactionEx = response.data.data;
              this.transactionLoaded = true;
              this.menu = {
                transactionName: this.transactionName,
                selected: true,
              };
              this.session = {
                loggedIn: true,
                details: {},
              };
              this.generalExApplicationEx = {
                generalEx: {
                  general: {},
                },
                applicationEx: {},
                theme: this.transactionEx.theme,
              };
              this.title = this.translatedConfig(
                this.generalExApplicationEx,
                this.customLanguage,
                this.transactionEx.transaction,
                "mainTitle"
              );
              this.doLoadFlap = true;
            } else {
              this.goToErrorServiceUnavaliable({
                mesage: this.getApiMessages(response.data, true),
              });
            }
          })
          .catch((errorRes) => {
            this.clearSession(this.applicationName);
            this.clearFrameworkSession();
            if (errorRes.response.status == 403) {
              this.launch();
            } else {
              this.goToErrorServiceUnavaliable({ mesage: errorRes });
            }
          });
      } else {
        this.goToErrorNotFound({});
      }
    },
    updateNotification(data) {
      const add = this.formattedNotification(data);
      this.notifications.push(...add);
      this.$refs.notificationRef.open();
      setTimeout(() => {
        this.cleanNotifications();
      }, this.timeoutNotif);
    },

    cleanNotifications() {
      this.historyNotif.concat(this.notifications);
      this.notifications = [];
    },
    switchLanguage() {
      this.customLanguage = this.changeLanguage(this.generalExApplicationEx);
    },
    okTransaction() {
      return this.transactionLoaded && this.transactionValidated;
    },
    transactionProcess(getSuccess, getData, getResponse) {
      if (getSuccess) {
        this.goToSuccess({
          message: this.getTranApiMessages(getResponse, false),
        });
      } else {
        this.goToErrorInternalServer({
          message: this.getTranApiMessages(getResponse, true),
          redirect: this.redirect,
        });
      }
    },
    launch() {
      this.validateFrameworkSession()
        .then(() => {
          this.transactionName = this.$route.params.transactionName;
          this.token = this.$route.params.token;
          this.inputData = this.$route.query;
          this.customLanguage = this.currentLanguage();
          this.redirect = location.href;
          this.loadTransaction();
        })
        .catch(() => {
          this.goToErrorUnauthorized({});
        });
    },
  },
  created() {
    this.launch();
  },
  updated() {
    if (this.doLoadFlap) {
      this.$refs.flapRef.callFlap(this.menu);
      this.doLoadFlap = false;
    }
  },
};
</script>

<style>
</style>